import axios from "./axiosInstance";

const newsEventAPI ={ 
    news_events_api: () => axios.get("events"),
    
    
}

export default newsEventAPI;